import $ from 'jquery';

class Leadership {
    constructor() {

    }

    init() {
        this.overlay = $('#staff-overlay');
        this.img = this.overlay.find('.staff__item-src-img');
        this.title = this.overlay.find('.staff__item-title');
        this.name = this.overlay.find('.staff__item-name');
        this.bio = this.overlay.find('.staff__bio');
        this.label = this.overlay.find('.staff__item-label');
        this.closebtn = this.overlay.find('.staff__close');
        this.body = this.overlay.find('.staff__body');
        this.components = $('.leadership.is-expandable');
        this.bindEvents();
    }

    bindEvents() {
        $('.leadership__item .leadership__read').each((e, d) => {
            $(d).on('click', (e) => {
                let staff = $(e.currentTarget).closest('.leadership__item');
                if (staff.length > 0) {
                    $(this.img).attr('src', $(staff).data('img'));
                    $(this.title).text($(staff).data('title'));
                    $(this.name).text($(staff).data('name'));
                    $(this.bio).html($(staff).data('bio'));
                    $(this.label).html($(staff).data('label'));
                }
                $(this.overlay).toggle();
            });
        });
        $(this.closebtn).on('click', () =>
        {
            this.closeModal();
        });
        $(this.overlay).on('click', (e) =>
        {
            if (e.target === this.body.get(0) || e.target === this.overlay.get(0)) {
                this.closeModal();
            }
        });
        $(this.components).each((e, component) => {
            let trigger = $(component).find('.leadership__trigger');
            trigger.on('click', () => {
                component.classList.toggle('is-open');
            });
        });
    }

    closeModal() {
        $(this.overlay).toggle();
        $(this.img).attr('src', '');
        $(this.title).text('');
        $(this.name).text('');
        $(this.bio).text('');
    }
}

export default Leadership;

$(() => {
    const leadership = new Leadership();
    leadership.init();
});
